/**
 * Ruta `/horarios` (008 · T043 · US1; contracts/ui.md §1.1): pestañas Cuadro de turnos (por
 * defecto), Turnos y, en lotes siguientes, Patrones, Feriados y Ausencias.
 *
 * `validateSearch` acepta `tab` del catálogo completo (`SCHEDULE_TAB_IDS`), así que esta ruta no
 * cambia cuando se registra una pestaña nueva (`features/schedules/schedules-page.tsx`). Lo que
 * no encaje se descarta y la pantalla arranca en `cuadro`. El cambio de pestaña usa `replace`.
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import {
  DEFAULT_SCHEDULE_TAB,
  isScheduleTab,
  SchedulesPage,
  type ScheduleTab,
} from '../../features/schedules/schedules-page';

export interface HorariosSearch {
  tab?: ScheduleTab;
}

export const Route = createFileRoute('/_app/horarios')({
  validateSearch: (search: Record<string, unknown>): HorariosSearch => {
    const tab = search['tab'];
    return isScheduleTab(tab) ? { tab } : {};
  },
  component: function HorariosRoute() {
    const { tab } = Route.useSearch();
    const navigate = useNavigate({ from: Route.fullPath });
    return (
      <SchedulesPage
        tab={tab ?? DEFAULT_SCHEDULE_TAB}
        onTabChange={(next) =>
          void navigate({ search: (prev) => ({ ...prev, tab: next }), replace: true })
        }
      />
    );
  },
});
